import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles } from '../style/gstheme';
import BarChartVisual from './BarChartVisual';

const styles = () => {
    return Object.assign({
        visualPanel: {
            width: '216px',
            height: '300px',
            paddingTop: 12,
            paddingLeft: 12,
            paddingRight: 12
        }
    }, globalStyles);
};

class ReportVisualisationContainer extends React.Component {

    componentDidMount() {
        BarChartVisual(this._rootNode, this.props.data, this.props.viz, this.props.defaultLang)
            .then((visual) => {
                this._visual = visual;
                this.setState({ initiated: true });
            });
    }

    _setRef(componentNode) {
        this._rootNode = componentNode;
    }

    render() {

        return <div data-test="report-viz" style={{
            width: '100%',
            height: '300px'
        }}>
            <svg style={{
                width: '100%',
                height: '100%'
            }} className="visualisation" ref={this._setRef.bind(this)} />
        </div>;
    }

}

ReportVisualisationContainer.propTypes = {
    defaultLang: PropTypes.string.isRequired,
    data: PropTypes.array,
    viz: PropTypes.array,
    classes: PropTypes.object
};

export default withStyles(styles)(ReportVisualisationContainer);